import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Col } from 'react-bootstrap';

class PageTitle extends Component {
	shouldComponentUpdate = ({ title : nextTitle }) => {
		const { title } = this.props;
		return nextTitle !== title;
	};

	render() {
		const { title } = this.props;

		return (
			<Grid>
				<Col
					md={9}
					xs={7}
					className="margin-top-30 margin-bottom-20"
				>
					<span className="color-dark font-light font-size-40">{ title }</span>
				</Col>
			</Grid>
		);
	}
}

PageTitle.propTypes = {
	title : PropTypes.string.isRequired,
};

export default PageTitle;
